module.exports = __webpack_public_path__ + "img/score1.96f6d780.png";